import {FollowersSvcFactory, State} from '../services/FollowersSvc';
import {HttpSvcFactory} from '../services/HttpSvc';
import {Utils} from 'underscore-extensions';

class FollowingCtrl implements ng.IComponentController {
    constructor(private $scope: any,
                private $rootScope: ng.IRootScopeService,
                private $state: ng.ui.IStateService,
                private $stateParams: any,
                private HttpSvc: HttpSvcFactory,
                private FollowersSvc: FollowersSvcFactory) {
        $scope.subjectUser = $stateParams.user;
        $scope.stateName = <State>$state.current.name;
        $scope.subjectUser = {
            username: $stateParams.username
        };
        $scope.sameUser = options.user.username === $scope.subjectUser.username;

        $scope.followersSvc = new FollowersSvc($scope.sameUser, (<State>$state.current.name));


        if ($scope.sameUser) {
            $scope.subjectUser = options.user;
        } else {
            updateProfile();
        }

        $scope.$watch('subjectUser', (u: anm.User) =>
            $rootScope.setTitle($scope.stateName + '.title', u.displayName));

        function updateProfile() {
            HttpSvc<ApiError | anm.User>($scope.subjectUser.username, 'profile').get()
                .then(response => {
                    const user = response.data;
                    if (Utils.isUser(user)) {
                        $rootScope.setTitle($scope.stateName + '.title', user.displayName);
                        $scope.subjectUser = user;
                    } else {
                        $state.go('studio-explore');
                    }
                });
        }
    }
}

angular.module('animatronApp.profileProject').component('followersPage', {
    controller: FollowingCtrl,
    templateUrl: require('following.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/FollowersPage.ts